import { useTheme, type Theme } from '@/core/theme';

const OPTIONS: { value: Theme; label: string; icon: string }[] = [
  { value: 'light', label: 'Claro', icon: '☀' },
  { value: 'dark', label: 'Oscuro', icon: '☾' },
  { value: 'system', label: 'Automático', icon: '⌘' },
];

/**
 * Three-state theme picker: light, dark, or follow the OS.
 *
 * A segmented control rather than a two-way toggle, because "follow the
 * system" is a real third state — with a toggle there is no way to get back to
 * it once you have touched it.
 */
export default function ThemeToggle({ className }: { className?: string }) {
  const { theme, setTheme } = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label="Tema"
      className={`inline-flex items-center gap-0.5 rounded-full border border-line bg-surface-sunken p-0.5 ${className ?? ''}`}
    >
      {OPTIONS.map((o) => {
        const active = theme === o.value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={active}
            title={o.label}
            onClick={() => setTheme(o.value)}
            className={`flex h-7 w-7 items-center justify-center rounded-full text-xs transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 ${
              active
                ? 'bg-surface-raised text-content shadow-sm'
                : 'text-content-subtle hover:text-content'
            }`}
          >
            <span aria-hidden="true">{o.icon}</span>
            <span className="sr-only">{o.label}</span>
          </button>
        );
      })}
    </div>
  );
}
